export default __webpack_public_path__ + "static/media/loading.f72cf097.gif";